import axios from 'axios';
import auth from '../utils/auth';
var DataLoader = require('dataloader');

export function getUserByEmail(emails) {
    return Promise.all(
        emails.map((email) => {
            return axios
                .request({
                    url: `/customers/${email}`,
                    headers: {
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getUserByEmailMin(emails) {
    return Promise.all(
        emails.map((email) => {
            return axios
                .request({
                    url: `/customers/${email}?fields=["_id", "email"]`,
                    headers: {
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getUserById(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/customers/${id}`,
                    headers: {
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getSOPsByType(types) {
    return Promise.all(
        types.map((type) => {
            return axios
                .request({
                    url: `/sop/${type}`,
                    headers: {
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getOrgsById(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/entities/${id}`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getUserCarts(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/customers/${id}/carts`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getUserOrders(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/customers/${id}/orders`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getUserAddresses(user_ids) {
    return Promise.all(
        user_ids.map((user_id) => {
            return axios
                .request({
                    url: `/customers/${user_id}/addresses`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getUserGrids(user_ids) {
    return Promise.all(
        user_ids.map((user_id) => {
            return axios
                .request({
                    url: `/entities/${user_id}/grids`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getUserSubs(user_ids) {
    return Promise.all(
        user_ids.map((user_id) => {
            return axios
                .request({
                    url: `/customers/${user_id}/sop_subs`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getAllOrgs(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/entities?fields=["name","entity_id", "category", "address.region"]`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getAllUsers(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/customers?fields=["email","_id","name"]`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID(),
                        'Customer-Id': auth.getUserId(),
                        Authorization: `Bearer ${auth.getToken()}`
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getAllOrgUsers(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/customers?where={"netsuite_entity":"${id}"}&fields=["email","_id","name","last_login","_modified"]`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

export function getOrders(ids) {
    return Promise.all(
        ids.map((id) => {
            return axios
                .request({
                    url: `/orders/search?page_size=10&sort=submitted_date:desc`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Session-Key': auth.getSID()
                    }
                })
                .then((resp) => resp.data);
        })
    );
}

const createLoaders = () => {
    return {
        all_orgs: new DataLoader(getAllOrgs),
        org: new DataLoader((orgs) => getOrgsById(orgs)),
        org_users: new DataLoader(getAllOrgUsers),
        all_users: new DataLoader(getAllUsers),
        user: new DataLoader((users) => getUserById(users)),
        user_email: new DataLoader((users) => getUserByEmail(users)),
        user_email_min: new DataLoader(getUserByEmailMin),
        user_carts: new DataLoader((users) => getUserCarts(users)),
        user_orders: new DataLoader(getUserOrders),
        user_addresses: new DataLoader(getUserAddresses),
        user_grids: new DataLoader(getUserGrids),
        user_sop: new DataLoader(getUserSubs),
        sop_list: new DataLoader((types) => getSOPsByType(types)),
        get_orders: new DataLoader(getOrders)
    };
};

export const loaders = createLoaders();
